import { useId, useState } from "react";
import { FAQS } from "../data/content";

export function Faq() {
  // Single-open accordion; first item open, -1 means all closed.
  const [openIndex, setOpenIndex] = useState(0);
  const baseId = useId();

  return (
    <section id="faq" className="section">
      <div className="container container--880">
        <div className="section-head">
          <h2 className="h2">FAQ</h2>
        </div>

        <div className="faq__list">
          {FAQS.map((item, index) => {
            const isOpen = openIndex === index;
            const panelId = `${baseId}-panel-${index}`;
            const buttonId = `${baseId}-button-${index}`;
            return (
              <div className="faq__item" key={item.q}>
                <h3 style={{ margin: 0 }}>
                  <button
                    type="button"
                    id={buttonId}
                    className="faq__button"
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  >
                    <span className="faq__q">{item.q}</span>
                    <span className="faq__sign" aria-hidden="true">
                      {isOpen ? "–" : "+"}
                    </span>
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  className={`faq__panel${isOpen ? " faq__panel--open" : ""}`}
                >
                  <div>
                    <p className="faq__a">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
